import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getBannedAllowedIPsPrivilege } from 'src/app/privileges/privileges.selector';
import { AllowedIpRegister } from '../allowed-ip-register';
import { AllowedIpPrivileges } from '../models/allowed-ip-privileges';
import { AllowedIpRegisterListItem } from '../models/allowed-ip-register-results.model';
import * as AllowedIpRegisterActions from '../state/allowed-ip-register.actions';
@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-allowed-ip-register',
   styleUrls: ['./allowed-ip-register.component.scss'],
   templateUrl: './allowed-ip-register.component.html',
   standalone: false,
})
export class AllowedIpRegisterComponent extends AllowedIpRegister {
   bannedallowedIpPrivileges$: Observable<AllowedIpPrivileges>;

   constructor(public store: Store) {
      super(store);

      this.bannedallowedIpPrivileges$ = store.pipe(select(getBannedAllowedIPsPrivilege));

      this.columns = [
         'ipAddress',
         'customerAccount',
         'qManageTicket',
         'originatingType',
         'status',
         'createdDate',
         'requestedBy',
         'allowedIpActionsMenu',
      ];
   }

   onDeleteAllowedIp(event: { allowedIpAddressId: number; ipAddress: string }): void {
      this.store.dispatch(AllowedIpRegisterActions.deleteAllowedIp(event));
   }
   onEdit(allowedIp: AllowedIpRegisterListItem): void {
      this.store.dispatch(AllowedIpRegisterActions.editAllowedIp({ allowedIp }));
   }
}
